import { ReactNode } from 'react'

interface PageHeaderProps {
  /** The menu label for this page, so the menu, the heading and the browser tab say the same thing. */
  title: ReactNode
  subtitle?: ReactNode
  /** Buttons, filters or tabs that act on the whole page. */
  actions?: ReactNode
  className?: string
}

/**
 * The top of a page: its H1 (21 px, weight 700, as in the design spec), an
 * optional line under it and the page's actions. The actions sit on the right
 * and wrap under the title when there isn't room; on a phone they get a line
 * of their own.
 */
export function PageHeader({ title, subtitle, actions, className = '' }: PageHeaderProps) {
  return (
    <div className={`flex flex-wrap items-start justify-between gap-x-4 gap-y-3 ${className}`}>
      <div className="min-w-0 flex-1 basis-64">
        <h1 className="font-display text-[21px] font-bold leading-tight tracking-[-0.3px] text-foreground">
          {title}
        </h1>
        {subtitle ? <p className="mt-1 text-sm text-foreground-muted">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex flex-wrap items-center gap-2 max-sm:w-full">{actions}</div> : null}
    </div>
  )
}
